import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ActivityFeed = ({ activities, onViewAll }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'installation': return 'Wrench';
      case 'upload': return 'Upload';
      case 'approval': return 'CheckCircle';
      case 'update': return 'Edit';
      case 'expired': return 'AlertTriangle';
      default: return 'Activity';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'installation': return 'text-primary';
      case 'upload': return 'text-secondary';
      case 'approval': return 'text-success';
      case 'update': return 'text-accent';
      case 'expired': return 'text-error';
      default: return 'text-muted-foreground';
    }
  };

  const formatTime = (timestamp) => {
    const now = new Date();
    const diff = now - timestamp;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
    return `${days}d ago`;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Recent Activities</h3>
        <Button variant="ghost" size="sm" onClick={onViewAll}>
          <Icon name="ExternalLink" size={16} />
          View All
        </Button>
      </div>
      <div className="space-y-4">
        {activities?.map((activity) => (
          <div key={activity?.id} className="flex items-start gap-3 p-3 rounded-lg hover:bg-muted/50 transition-colors duration-200">
            <div className={`w-8 h-8 rounded-full bg-muted flex items-center justify-center flex-shrink-0 ${getActivityColor(activity?.type)}`}>
              <Icon name={getActivityIcon(activity?.type)} size={16} />
            </div>
            
            <div className="flex-1 min-w-0">
              <p className="text-sm text-foreground font-medium">{activity?.title}</p>
              <p className="text-xs text-muted-foreground mt-1">{activity?.description}</p>
              <div className="flex items-center gap-2 mt-2">
                <span className="text-xs text-muted-foreground">{activity?.store}</span>
                <span className="text-xs text-muted-foreground">•</span>
                <span className="text-xs text-muted-foreground">{formatTime(activity?.timestamp)}</span>
              </div>
            </div>

            {activity?.status && (
              <div className={`px-2 py-1 rounded-full text-xs font-medium ${
                activity?.status === 'completed' ? 'bg-success/10 text-success' :
                activity?.status === 'pending'? 'bg-warning/10 text-warning' : 'bg-muted text-muted-foreground'
              }`}>
                {activity?.status}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityFeed;